import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";

const Theme = createMuiTheme({
	palette: {
		primary: {
			main: "#006677",
		},
		secondary: {
			main: "#F1EEE9",
		},
		background: {
			default: "#FFFFFF",
		},
	},
	typography: {
		fontFamily: "Raleway, Arial",
	},
});

export default responsiveFontSizes(Theme);
